<div id="mous" class="inner-page">
  <div class="mou-container">

    <!-- Premium Centered Header -->
    <div class="mou-header text-center mb-4">
      <h2 class="college-title">Shah Satnam Ji Girls' College, Sirsa</h2>
      <h3 class="mou-title">Memorandum of Understanding(MOU)</h3>
    </div>

    <!-- Description Paragraph (Subtle & Centered) -->
    <p class="inner-lead text-center max-width-lead mx-auto mb-4">
      Shah Satnam Ji Girls' College, Sirsa has signed Memoranda of Understanding (MoUs) with various institutions,
      organizations, and industries to promote academic collaboration, student training, and professional development.
    </p>

    <!-- MoU Gallery Grid (Premium Modern Cards) -->
    <div class="mou-gallery">
      <!-- 1 -->
      <div class="mou-card">
        <img src="assets/img/mous/1.jpg" alt="MoU Ceremony 1"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 2 -->
      <div class="mou-card">
        <img src="assets/img/mous/2.jpg" alt="MoU Ceremony 2"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 3 -->
      <div class="mou-card">
        <img src="assets/img/mous/3.jpg" alt="MoU Ceremony 3"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 4 -->
      <div class="mou-card">
        <img src="assets/img/mous/4.jpg" alt="MoU Ceremony 4"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 5 -->
      <div class="mou-card">
        <img src="assets/img/mous/5.jpg" alt="MoU Ceremony 5"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 6 -->
      <div class="mou-card">
        <img src="assets/img/mous/6.jpg" alt="MoU Ceremony 6"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 7 -->
      <div class="mou-card">
        <img src="assets/img/mous/7.jpg" alt="MoU Media Coverage 1"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 8 -->
      <div class="mou-card">
        <img src="assets/img/mous/8.jpg" alt="MoU Media Coverage 2"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 9 -->
      <div class="mou-card">
        <img src="assets/img/mous/9.jpg" alt="MoU Ceremony 9"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 10 -->
      <div class="mou-card">
        <img src="assets/img/mous/10.jpeg" alt="MoU Ceremony 10"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 11 -->
      <div class="mou-card">
        <img src="assets/img/mous/11.jpeg" alt="MoU Ceremony 11"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 12 -->
      <div class="mou-card">
        <img src="assets/img/mous/12.jpeg" alt="MoU Ceremony 12"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 13 -->
      <div class="mou-card">
        <img src="assets/img/mous/13.jpeg" alt="MoU Ceremony 13"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
      <!-- 14 -->
      <div class="mou-card">
        <img src="assets/img/mous/14.jpeg" alt="MoU Ceremony 14"
          onerror="this.src='assets/img/logo/logo1.png'; this.style.opacity='0.5'">
      </div>
    </div>

    <!-- YEAR 2025-26 Table -->
    <div class="mou-table-container">
      <table class="mou-table">
        <thead>
          <tr class="year-header">
            <th colspan="3">YEAR: 2025-26</th>
          </tr>
          <tr class="column-header">
            <th style="width: 8%; text-align: center;">S.No</th>
            <th style="width: 22%;">Date</th>
            <th>Name of Party/Institution/Industry, NGO etc.</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="text-align: center;">1</td>
            <td>25.09.2025</td>
            <td>SIRCL Tech. Pvt. Ltd</td>
          </tr>
          <tr>
            <td style="text-align: center;">2</td>
            <td>08.10.2025</td>
            <td>Life Insurance Corporation of India, Sirsa</td>
          </tr>
          <tr>
            <td style="text-align: center;">3</td>
            <td>09.10.2025</td>
            <td>Narang Hospital , Sirsa</td>
          </tr>
          <tr>
            <td style="text-align: center;">4</td>
            <td>15.10.2025</td>
            <td>HDFC Bank</td>
          </tr>
          <tr>
            <td style="text-align: center;">5</td>
            <td>06.11.2025</td>
            <td>Sarla Memorial Govt. Girls College, Safidon, Jind</td>
          </tr>
          <tr>
            <td style="text-align: center;">6</td>
            <td>06.11.2025</td>
            <td>Department Of Physical Education, Guru Kashi University, Talwandi Sabo</td>
          </tr>
          <tr>
            <td style="text-align: center;">7</td>
            <td>23.02.2026</td>
            <td>Govt. College, Goriwala</td>
          </tr>
          <tr>
            <td style="text-align: center;">8</td>
            <td>23.02.2026</td>
            <td>Govt. College for Girls, Rania</td>
          </tr>
          <tr>
            <td style="text-align: center;">9</td>
            <td>26.02.2026</td>
            <td>Manohar Memorial college, Fatehabad</td>
          </tr>
          <tr>
            <td style="text-align: center;">10</td>
            <td>18.05.2026</td>
            <td>Samarghosh Infotech</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- YEAR 2024-25 Table -->
    <div class="mou-table-container">
      <table class="mou-table">
        <thead>
          <tr class="year-header">
            <th colspan="3">YEAR: 2024-25</th>
          </tr>
          <tr class="column-header">
            <th style="width: 8%; text-align: center;">S.No</th>
            <th style="width: 22%;">Date</th>
            <th>Name of Party/Institution/Industry, NGO etc.</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="text-align: center;">1</td>
            <td>09.10.2024</td>
            <td>GCW, Sirsa</td>
          </tr>
          <tr>
            <td style="text-align: center;">2</td>
            <td>21.11.2024</td>
            <td>Great Future Technology Pvt . Ltd</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- YEAR 2023-24 Table -->
    <div class="mou-table-container">
      <table class="mou-table">
        <thead>
          <tr class="year-header">
            <th colspan="3">YEAR: 2023-24</th>
          </tr>
          <tr class="column-header">
            <th style="width: 8%; text-align: center;">S.No</th>
            <th style="width: 22%;">Date</th>
            <th>Name of Party/Institution/Industry, NGO etc.</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="text-align: center;">1</td>
            <td>08 Feb, 2024</td>
            <td>Kuber Agro Industry, Village- Moriwala, Distt. Sirsa</td>
          </tr>
          <tr>
            <td style="text-align: center;">2</td>
            <td>08 April, 2024</td>
            <td>Red Cross Society, Sirsa</td>
          </tr>
          <tr>
            <td style="text-align: center;">3</td>
            <td>15 April, 2024</td>
            <td>Softech Infoways, Suvidha Marg, Aggarsain Colony, Sirsa</td>
          </tr>
          <tr>
            <td style="text-align: center;">4</td>
            <td>16 April, 2024</td>
            <td>Post Office, Sirsa, Haryana</td>
          </tr>
          <tr>
            <td style="text-align: center;">5</td>
            <td>18 April, 2024</td>
            <td>ICICI Bank, Sirsa</td>
          </tr>
          <tr>
            <td style="text-align: center;">6</td>
            <td>18 April, 2024</td>
            <td>Yog Mitra Charitable Trust, Sirsa</td>
          </tr>
          <tr>
            <td style="text-align: center;">7</td>
            <td>20 April, 2024</td>
            <td>Satguru Industries, Sirsa Haryana</td>
          </tr>
          <tr>
            <td style="text-align: center;">8</td>
            <td>26 April, 2024</td>
            <td>Institution of Charted Accountants of India (ICAI), Sirsa</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- YEAR 2022-23 Table -->
    <div class="mou-table-container">
      <table class="mou-table">
        <thead>
          <tr class="year-header">
            <th colspan="3">YEAR: 2022-23</th>
          </tr>
          <tr class="column-header">
            <th style="width: 8%; text-align: center;">S.No</th>
            <th style="width: 22%;">Date</th>
            <th>Name of Party/Institution/Industry, NGO etc.</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="text-align: center;">1</td>
            <td>17 Jun, 2022</td>
            <td>Sanatan Dharama College, Ambala Cantt.</td>
          </tr>
          <tr>
            <td style="text-align: center;">2</td>
            <td>28 Jan, 2023</td>
            <td>Chaudhary Mani Ram Jhorar Govt College, Mithi Surera, Ellenabad</td>
          </tr>
          <tr>
            <td style="text-align: center;">3</td>
            <td>14 Feb, 2023</td>
            <td>Chaudhary Mani Ram Godara Govt College for Women, Bodia khera, Fatehabad</td>
          </tr>
          <tr>
            <td style="text-align: center;">4</td>
            <td>09 May, 2023</td>
            <td>Chandan Mal Karnani National Post Graduate College, Sirsa</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- YEAR 2021-22 Table -->
    <div class="mou-table-container">
      <table class="mou-table">
        <thead>
          <tr class="year-header">
            <th colspan="3">YEAR: 2021-22</th>
          </tr>
          <tr class="column-header">
            <th style="width: 8%; text-align: center;">S.No</th>
            <th style="width: 22%;">Date</th>
            <th>Name of Party/Institution/Industry, NGO etc.</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="text-align: center;">1</td>
            <td>28 May, 2022</td>
            <td>Government National College, Sirsa</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>